export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
};

export type AccessesNestedInput = {
  has?: InputMaybe<RouteAccess>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddToBlacklistDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type AdditionalBus = {
  __typename?: 'AdditionalBus';
  blockedSeats: Array<BusScheme>;
  bus?: Maybe<Bus>;
  busId?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<User>;
  carrierId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type AdditionalBusConnectDisconnectInput = {
  connect?: InputMaybe<AdditionalBusWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdditionalBusCreateDataInput = {
  busId: Scalars['String']['input'];
  carrierId: Scalars['String']['input'];
};

export type AdditionalBusHistoryData = {
  __typename?: 'AdditionalBusHistoryData';
  bus?: Maybe<Bus>;
  carrier?: Maybe<User>;
};

export type AdditionalBusUpsertDataInput = {
  busId: Scalars['String']['input'];
  carrierId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalBusWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AdditionalBusesUpdateDataInput = {
  delete?: InputMaybe<Array<AdditionalBusWhereUniqueInput>>;
  upsert?: InputMaybe<Array<AdditionalBusUpsertDataInput>>;
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: CountryCode;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ArchiveOrderDataInput = {
  isWithNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AsCompanyPassengerDataInput = {
  companyId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PassengerStatus>;
};

export type AvailableSeatsPayload = {
  __typename?: 'AvailableSeatsPayload';
  blockedSeats: Array<BusScheme>;
  bus?: Maybe<Bus>;
  route: Route;
  seats: Array<Seat>;
  seatsLeft: Scalars['Int']['output'];
};

export type AvailableSeatsWhereInput = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type Blacklist = {
  __typename?: 'Blacklist';
  color?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  passenger: Passenger;
  passengerId: Scalars['String']['output'];
};

export type BlacklistWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BlockedSeatsConnectDisconnectInput = {
  connect: Array<BusSchemeWhereUniqueInput>;
  disconnect: Array<BusSchemeWhereUniqueInput>;
};

export type BlockedSeatsWhereInput = {
  additionalBusId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export type BlogArticle = {
  __typename?: 'BlogArticle';
  category: BlogArticleCategory;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  metadataId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum BlogArticleCategory {
  Articles = 'Articles',
  News = 'News',
  Tips = 'Tips'
}

export type BlogArticleWhereInput = {
  category?: InputMaybe<BlogArticleCategory>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BlogArticleWhereUniqueInput = {
  slug: Scalars['String']['input'];
};

export type BookingsLeftWhereInput = {
  departureDate: Scalars['DateTime']['input'];
  route: RouteWhereUniqueInput;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BorderWaitingTime = {
  __typename?: 'BorderWaitingTime';
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySlug?: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['DateTime']['output'];
  minMaxTime: Array<Scalars['Int']['output']>;
  routeName: Scalars['String']['output'];
  weekday: Scalars['String']['output'];
};

export type Bus = {
  __typename?: 'Bus';
  brand: Scalars['String']['output'];
  companies: Array<Company>;
  fmsObjects: Array<FmsObject>;
  hasScheme: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  images: Array<Image>;
  model: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
  scheme: Array<BusScheme>;
  seatsQty: Scalars['Int']['output'];
};


export type BusCompaniesArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type BusFmsObjectsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FmsObjectWhereInput>;
};

export type BusConnectDisconnectInput = {
  connect?: InputMaybe<BusWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusCreateOrConnectInput = {
  create: CreateBusDataInput;
  where: BusWhereUniqueInput;
};

export type BusLocation = {
  __typename?: 'BusLocation';
  bus: Bus;
  busId: Scalars['String']['output'];
  carriage?: Maybe<Carriage>;
  carriageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  route: Route;
  routeId: Scalars['String']['output'];
};

export type BusLocationWhereInput = {
  busId: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export type BusScheme = {
  __typename?: 'BusScheme';
  asOrderSeat: Array<Order>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: BusSchemeType;
  xAxis: Scalars['Int']['output'];
  yAxis: Scalars['Int']['output'];
  zAxis: Scalars['Int']['output'];
};

export enum BusSchemeType {
  Door = 'Door',
  Other = 'Other',
  Seat = 'Seat',
  SpecialSeat = 'SpecialSeat',
  Stairs = 'Stairs',
  Table = 'Table',
  Wc = 'WC'
}

export type BusSchemeWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BusSystemOrdersWhereInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type BusSystemRoute = {
  __typename?: 'BusSystemRoute';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  route?: Maybe<Route>;
};

export type BusSystemRouteConnectInput = {
  connect?: InputMaybe<BusSystemRouteWhereUniqueInput>;
};

export type BusSystemRouteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BusSystemTicket = {
  __typename?: 'BusSystemTicket';
  createdAt: Scalars['DateTime']['output'];
  dateFrom: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pointFromName: Scalars['String']['output'];
  pointToName: Scalars['String']['output'];
  route: BusSystemRoute;
  surname: Scalars['String']['output'];
};

export enum BusSystemTicketStatus {
  Buy = 'buy',
  Cancel = 'cancel',
  Reserve = 'reserve'
}

export type BusSystemTicketWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Carriage = {
  __typename?: 'Carriage';
  carrier?: Maybe<User>;
  carrierId?: Maybe<Scalars['String']['output']>;
  customDays: Array<Scalars['String']['output']>;
  discounts: Array<Discount>;
  frequency: CarriageFrequency;
  id: Scalars['String']['output'];
  nDay?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  phones: Array<Scalars['String']['output']>;
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum CarriageFrequency {
  Custom = 'Custom',
  EveryNDay = 'EveryNDay'
}

export type CarriageOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type CarriageOrderDataInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CarriageWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CarrierByDate = {
  __typename?: 'CarrierByDate';
  carrier?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type CarrierOrdersWhereInput = {
  carrierId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CarriersByDatesWhereInput = {
  endDate: Scalars['DateTime']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CheckContrabusBookingPayload = {
  __typename?: 'CheckContrabusBookingPayload';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageHtml?: Maybe<Scalars['String']['output']>;
};

export type CheckContrabusBookingWhereInput = {
  dataBundle: Scalars['String']['input'];
  phones: Array<Scalars['String']['input']>;
};

export type City = {
  __typename?: 'City';
  country: CountryCode;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stops: Array<CityStop>;
  timeZone?: Maybe<Scalars['String']['output']>;
  translations: Array<CityTranslation>;
};

export type CityStop = {
  __typename?: 'CityStop';
  city: City;
  cityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  place: Scalars['String']['output'];
  type: CityStopType;
};

export type CityStopConnectDisconnectInput = {
  connect?: InputMaybe<CityStopWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CityStopConnectInput = {
  connect?: InputMaybe<CityStopWhereUniqueInput>;
};

export enum CityStopType {
  Airport = 'Airport',
  BusStation = 'BusStation',
  Regular = 'Regular',
  TrainStation = 'TrainStation'
}

export type CityStopWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CityTranslation = {
  __typename?: 'CityTranslation';
  id: Scalars['String']['output'];
  language: Language;
  languageId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CityWhereInput = {
  country?: InputMaybe<EnumCountryCodeFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};

export type CityWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ClosestAvailableOffers = {
  __typename?: 'ClosestAvailableOffers';
  dates: Array<Scalars['DateTime']['output']>;
};

export type CompaniesConnectDisconnectInput = {
  connect?: InputMaybe<Array<CompanyWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CompanyWhereUniqueInput>>;
};

export type Company = {
  __typename?: 'Company';
  addresses: Array<Address>;
  apiKey?: Maybe<Scalars['String']['output']>;
  busSystemLogin?: Maybe<Scalars['String']['output']>;
  busSystemPassword?: Maybe<Scalars['String']['output']>;
  buses: Array<Bus>;
  ceo?: Maybe<Scalars['String']['output']>;
  dispatcherCommission?: Maybe<Scalars['Decimal']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fbPages: Array<FbPage>;
  fmsObjects: Array<FmsObject>;
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationsEmail?: Maybe<Scalars['String']['output']>;
  notificationsPhone?: Maybe<Scalars['String']['output']>;
  origins: Array<Origin>;
  partnerCommission?: Maybe<Scalars['Decimal']['output']>;
  partnerCompany?: Maybe<Scalars['String']['output']>;
  passengers: Array<CompanyPassenger>;
  phones: Array<Phone>;
  plan?: Maybe<Plan>;
  prexsellCommission?: Maybe<Scalars['Decimal']['output']>;
  refundRules?: Maybe<Array<CompanyRefundRule>>;
  review?: Maybe<CompanyReview>;
  reviewLink?: Maybe<Scalars['String']['output']>;
  reviews: Array<Review>;
  routes: Array<Route>;
  rules?: Maybe<Scalars['String']['output']>;
  sharedRoutes: Array<SharedRoute>;
  shortcuts: Array<CompanyShortcut>;
  slug?: Maybe<Scalars['String']['output']>;
  socials: Array<Scalars['String']['output']>;
  sources: Array<CompanySource>;
  status: CompanyStatus;
  tierFee?: Maybe<Scalars['Decimal']['output']>;
  users: Array<CompanyUser>;
  website?: Maybe<Scalars['String']['output']>;
  websiteConfig?: Maybe<WebsiteConfig>;
  websiteConfigId?: Maybe<Scalars['String']['output']>;
};


export type CompanyBusesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyReviewsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewWhereInput>;
};


export type CompanyRoutesArgs = {
  orderBy?: InputMaybe<RouteOrderByInput>;
  where?: InputMaybe<RouteWhereInput>;
};


export type CompanySharedRoutesArgs = {
  where?: InputMaybe<SharedRouteWhereInput>;
};


export type CompanyTierFeeArgs = {
  where: CompanyTierFeeWhereInput;
};


export type CompanyUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type CompanyAddressNestedObjectInputType = {
  create?: InputMaybe<Array<CreateCompanyAddressDataInput>>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
};

export type CompanyBusNestedObjectInputType = {
  connectOrCreate?: InputMaybe<Array<BusCreateOrConnectInput>>;
  disconnect?: InputMaybe<Array<BusWhereUniqueInput>>;
};

export type CompanyConnectDisconnectInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
  disconnect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyConnectInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyPassenger = {
  __typename?: 'CompanyPassenger';
  company: Company;
  companyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: PassengerStatus;
};

export type CompanyPhoneNestedObjectInputType = {
  create?: InputMaybe<Array<CreatePhoneDataInput>>;
  disconnect?: InputMaybe<Array<PhoneWhereUniqueInput>>;
};

export type CompanyRefundRule = {
  __typename?: 'CompanyRefundRule';
  amount: Scalars['Decimal']['output'];
  hours: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
};

export type CompanyRefundRuleWhereInput = {
  companyId: Scalars['String']['input'];
};

export type CompanyRefundRuleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CompanyReview = {
  __typename?: 'CompanyReview';
  bus: Scalars['Float']['output'];
  comfort: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  drivers: Scalars['Float']['output'];
  priceQuality: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  support: Scalars['Float']['output'];
};

export type CompanyRoutesCarriagesPayload = {
  __typename?: 'CompanyRoutesCarriagesPayload';
  carriages: Array<Carriage>;
  name: Scalars['String']['output'];
};

export type CompanyShortcut = {
  __typename?: 'CompanyShortcut';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type CompanyShortcutWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CompanySource = {
  __typename?: 'CompanySource';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CompanySourceConnectInput = {
  connect?: InputMaybe<CompanySourceWhereUniqueInput>;
};

export type CompanySourceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export enum CompanyStatus {
  Disabled = 'Disabled',
  Private = 'Private',
  Public = 'Public'
}

export type CompanyTierFeeWhereInput = {
  endDate: Scalars['DateTime']['input'];
  filterBy: FilterOrdersBy;
  startDate: Scalars['DateTime']['input'];
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  role: UserRole;
  selectedRoutes: Array<SelectedRoute>;
  user: User;
  userId: Scalars['String']['output'];
};

export type CompanyUserCreateDeleteInput = {
  create?: InputMaybe<Array<CreateCompanyUserDataInput>>;
  delete?: InputMaybe<Array<CompanyUserWhereUniqueInput>>;
};

export type CompanyUserWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CompanyWebsiteConfigNestedObjectInputType = {
  additionalRoutesCompanies?: InputMaybe<CompaniesConnectDisconnectInput>;
  additionalRoutesSources?: InputMaybe<Array<OrderRouteSource>>;
  applePayDomainFileUrl?: InputMaybe<Scalars['String']['input']>;
  defaultMetadata?: InputMaybe<MetadataNestedObjectInputType>;
  faviconUrl?: InputMaybe<Scalars['String']['input']>;
  heroImageUrl?: InputMaybe<Scalars['String']['input']>;
  liqpayPrivateKey?: InputMaybe<Scalars['String']['input']>;
  liqpayPublicKey?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
};

export type CompanyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmCompanyDataInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConfirmPartnerDataInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  fbPage?: Maybe<FbPage>;
  fbPageId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  messages: Array<Message>;
  messagesCount: Scalars['Int']['output'];
  participants: Array<Passenger>;
  phone?: Maybe<Phone>;
  phoneId?: Maybe<Scalars['String']['output']>;
  source: Messenger;
};


export type ConversationMessagesArgs = {
  orderBy?: InputMaybe<ConversationMessagesOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationMessagesOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type ConversationWhereInput = {
  source?: InputMaybe<Messenger>;
};

export type ConversationWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CopyRouteDataInput = {
  name: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export enum CountryCode {
  At = 'AT',
  Be = 'BE',
  Bg = 'BG',
  Ch = 'CH',
  Cz = 'CZ',
  De = 'DE',
  Ee = 'EE',
  Es = 'ES',
  Fr = 'FR',
  Gr = 'GR',
  Hu = 'HU',
  It = 'IT',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Md = 'MD',
  Nl = 'NL',
  Pl = 'PL',
  Ro = 'RO',
  Sk = 'SK',
  Ua = 'UA'
}

export type CreateAsCompanyPassengerDataInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  status: PassengerStatus;
};

export type CreateBlogArticleDataInput = {
  category: BlogArticleCategory;
  content: Scalars['String']['input'];
  metadata?: InputMaybe<CreateBlogArticleMetadataDataInput>;
  slug: Scalars['String']['input'];
  thumbnailUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateBlogArticleMetadataDataInput = {
  create: CreateMetadataDataInput;
};

export type CreateBusDataInput = {
  brand: Scalars['String']['input'];
  images?: InputMaybe<ImageNestedObjectInputType>;
  model: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
  seatsQty: Scalars['Int']['input'];
};

export type CreateBusSchemeDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  type: BusSchemeType;
  xAxis: Scalars['Int']['input'];
  yAxis: Scalars['Int']['input'];
  zAxis: Scalars['Int']['input'];
};

export type CreateCarriageDataInput = {
  carrier: UserConnectDisconnectInput;
  customDays?: InputMaybe<Array<Scalars['String']['input']>>;
  discounts?: InputMaybe<DiscountCreateNestedObjectInputType>;
  frequency: CarriageFrequency;
  nDay?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  route: RouteConnectInput;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCityDataInput = {
  country: CountryCode;
  name: Scalars['String']['input'];
  translations: Array<CreateCityTranslationDataInput>;
};

export type CreateCityStopDataInput = {
  city: CityStopConnectInput;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  place: Scalars['String']['input'];
};

export type CreateCityTranslationDataInput = {
  language: LanguageCode;
  name: Scalars['String']['input'];
};

export type CreateCompanyAddressDataInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: CountryCode;
  description?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateCompanyRefundRuleDataInput = {
  amount: Scalars['Decimal']['input'];
  companyId: Scalars['String']['input'];
  hours: Scalars['Decimal']['input'];
};

export type CreateCompanyShortcutDataInput = {
  label: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type CreateCompanySourceDataInput = {
  company: CompanyConnectInput;
  name: Scalars['String']['input'];
};

export type CreateCompanyUserDataInput = {
  company: CompanyConnectInput;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

export type CreateExchangeRateDataInput = {
  currency: CurrencyCode;
  value: Scalars['Decimal']['input'];
};

export type CreateFbPageDataInput = {
  accessToken: Scalars['String']['input'];
  instagramId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type CreateImageDataInput = {
  busId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type CreateManyBusSchemeDataInput = {
  data: Array<InputMaybe<CreateBusSchemeDataInput>>;
};

export type CreateMessageAttachmentDataInput = {
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateMessageDataInput = {
  attachments: Array<CreateMessageAttachmentDataInput>;
  conversationId: Scalars['String']['input'];
  replayToId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMetadataDataInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrderDataInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<OriginConnectInput>;
  passengers: Array<CreateOrderPassengerDataInput>;
  paymentStatus: PaymentStatus;
  status?: InputMaybe<OrderStatus>;
};

export type CreateOrderPassengerDataInput = {
  blaBlaCarRaceId?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyCode;
  departureDate: Scalars['DateTime']['input'];
  discountDesc?: InputMaybe<Scalars['String']['input']>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  octobusRaceId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  paymentRecipient?: InputMaybe<OrderPaymentRecipient>;
  phones: Array<CreatePhoneDataInput>;
  prepaid?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  seats?: InputMaybe<Array<PassengerSeatDataInput>>;
  source: OrderRouteSource;
};

export type CreateOriginDataInput = {
  company: CompanyConnectInput;
  name: Scalars['String']['input'];
};

export type CreatePartnerCommissionDataInput = {
  amount: Scalars['Decimal']['input'];
  company?: InputMaybe<CompanyConnectInput>;
  partner: PartnerConnectInput;
  source: OrderRouteSource;
};

export type CreatePassengerDataInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phones: Array<PhoneWhereUniqueInput>;
  socials?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<PassengerStatus>;
};

export type CreatePhoneDataInput = {
  eChatApiKey?: InputMaybe<Scalars['String']['input']>;
  messengers?: InputMaybe<Array<Messenger>>;
  phone: Scalars['String']['input'];
};

export type CreatePriceDataInput = {
  amount: Scalars['Float']['input'];
  currency: CurrencyCode;
};

export type CreatePromocodeDataInput = {
  amount: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rule: PromocodeRule;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRouteByDateDataInput = {
  additionalBuses?: InputMaybe<Array<AdditionalBusCreateDataInput>>;
  bus?: InputMaybe<BusConnectDisconnectInput>;
  carrier?: InputMaybe<UserConnectDisconnectInput>;
  date: Scalars['DateTime']['input'];
  firstDriver?: InputMaybe<UserConnectDisconnectInput>;
  generalInfo?: InputMaybe<Scalars['String']['input']>;
  infoForDrivers?: InputMaybe<Scalars['String']['input']>;
  infoForPartners?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  ordersLimit?: InputMaybe<Scalars['Int']['input']>;
  route: RouteConnectInput;
  secondDriver?: InputMaybe<UserConnectDisconnectInput>;
  thirdDriver?: InputMaybe<UserConnectDisconnectInput>;
};

export type CreateRouteDataInput = {
  company: CompanyConnectInput;
  defaultOrdersLimit: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isInternational?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  returnDay?: InputMaybe<Scalars['Int']['input']>;
  returnRoute?: InputMaybe<RouteConnectInput>;
  status?: InputMaybe<RouteStatus>;
};

export type CreateSelectedRouteDataInput = {
  isSelected: Scalars['Boolean']['input'];
  routeId: Scalars['String']['input'];
};

export type CreateSourceByDateDataInput = {
  date: Scalars['DateTime']['input'];
  ordersLimit: Scalars['Int']['input'];
  source: SourceConnectInput;
};

export type CreateSourceDataInput = {
  asCompanySource?: InputMaybe<CompanySourceConnectInput>;
  commission: Scalars['Float']['input'];
  defaultDepartureStop?: InputMaybe<StopConnectInput>;
  defaultOrdersLimit: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  route: RouteConnectInput;
};

export type CreateSourceOrderDataInput = {
  departureDate: Scalars['DateTime']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  passengers: Scalars['Int']['input'];
  source?: InputMaybe<SourceConnectInput>;
};

export type CreateStopByDateDataInput = {
  date: Scalars['DateTime']['input'];
  isDisabled: Scalars['Boolean']['input'];
  stop: StopConnectInput;
};

export type CreateStopDataInput = {
  arrivalDay: Scalars['Int']['input'];
  arrivalTime?: InputMaybe<Scalars['String']['input']>;
  cityStop: CityStopConnectInput;
  departureDay: Scalars['Int']['input'];
  departureTime?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  route: RouteConnectInput;
};

export type CreateTransferDataInput = {
  fromStopId: Scalars['String']['input'];
  toStopId: Scalars['String']['input'];
};

export type CreateUserDataInput = {
  asCompaniesUser?: InputMaybe<CompanyUserCreateDeleteInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum CurrencyCode {
  Czk = 'CZK',
  Eur = 'EUR',
  Pln = 'PLN',
  Uah = 'UAH',
  Usd = 'USD'
}

export type Dashboard = {
  __typename?: 'Dashboard';
  bookedTickets: Scalars['Int']['output'];
  canceledOrders: Scalars['Int']['output'];
  ordersByDate: Array<DateOrders>;
  ordersCreated: Scalars['Int']['output'];
  soldTickets: Scalars['Int']['output'];
};

export type DashboardWhereInput = {
  dateBy: DateBy;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export enum DateBy {
  CreatedAt = 'CreatedAt',
  DepartureDate = 'DepartureDate'
}

export type DateOrders = {
  __typename?: 'DateOrders';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type DateTimeFilter = {
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rule?: Maybe<DiscountRule>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscountCreateDataInput = {
  amount: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  rule: DiscountRule;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiscountCreateNestedObjectInputType = {
  create?: InputMaybe<Array<DiscountCreateDataInput>>;
};

export type DiscountNestedObjectInputType = {
  upsert?: InputMaybe<Array<DiscountUpsertInput>>;
};

export enum DiscountRule {
  Amount = 'Amount',
  Overwrite = 'Overwrite',
  Percent = 'Percent'
}

export type DiscountUpdateDataInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<DiscountRule>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiscountUpsertInput = {
  create: DiscountCreateDataInput;
  update: DiscountUpdateDataInput;
  where: DiscountWhereUniqueInput;
};

export type DiscountWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type DuplicatedOrderWhereInput = {
  offerId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DynamicPrice = {
  __typename?: 'DynamicPrice';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['String']['output']>;
  rule: DynamicPriceRule;
  startDate: Scalars['DateTime']['output'];
};

export type DynamicPriceCreateDataInput = {
  amount: Scalars['Float']['input'];
  endDate: Scalars['DateTime']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
  rule: DynamicPriceRule;
  startDate: Scalars['DateTime']['input'];
  transferId?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicPriceNestedObjectInputType = {
  delete?: InputMaybe<Array<DynamicPriceWhereUniqueInput>>;
  upsert?: InputMaybe<Array<DynamicPriceUpsertInput>>;
};

export enum DynamicPriceRule {
  Amount = 'Amount',
  Overwrite = 'Overwrite',
  Percent = 'Percent'
}

export type DynamicPriceUpdateDataInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<DynamicPriceRule>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  transferId?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicPriceUpsertInput = {
  create: DynamicPriceCreateDataInput;
  update: DynamicPriceUpdateDataInput;
  where: DynamicPriceWhereUniqueInput;
};

export type DynamicPriceWhereInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  price?: InputMaybe<PriceWhereInput>;
  routeId?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<DynamicPriceRule>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  transferId?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicPriceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EnumCountryCodeFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<EnumCountryCodeFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumLanguageCodeFilter = {
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<EnumLanguageCodeFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumOrderChannelFilter = {
  equals?: InputMaybe<OrderChannel>;
  in?: InputMaybe<Array<OrderChannel>>;
  not?: InputMaybe<EnumOrderChannelFilter>;
  notIn?: InputMaybe<Array<OrderChannel>>;
};

export type EnumOrderPaymentProviderFilter = {
  equals?: InputMaybe<OrderPaymentProvider>;
  in?: InputMaybe<Array<OrderPaymentProvider>>;
  not?: InputMaybe<EnumOrderPaymentProviderFilter>;
  notIn?: InputMaybe<Array<OrderPaymentProvider>>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<EnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<EnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumRouteStatusFilter = {
  equals?: InputMaybe<RouteStatus>;
  in?: InputMaybe<Array<RouteStatus>>;
  not?: InputMaybe<EnumRouteStatusFilter>;
  notIn?: InputMaybe<Array<RouteStatus>>;
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  createdAt: Scalars['DateTime']['output'];
  currency: CurrencyCode;
  id: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type ExternalOfferData = {
  __typename?: 'ExternalOfferData';
  blaBlaCarRaceId?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  octobusRaceId?: Maybe<Scalars['String']['output']>;
};

export type ExternalOfferDataWhereInput = {
  externalOfferId: Scalars['String']['input'];
  routeSource: OrderRouteSource;
};

export type ExternalOfferPriceWhereInput = {
  currency: CurrencyCode;
  externalOfferId: Scalars['String']['input'];
  routeSource: OrderRouteSource;
};

export type FbPage = {
  __typename?: 'FbPage';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresOn: Scalars['DateTime']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
};

export type FbPageWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export enum FilterOrdersBy {
  CreatedAt = 'CreatedAt',
  DepartureDate = 'DepartureDate'
}

export type FmsObject = {
  __typename?: 'FmsObject';
  bus: Bus;
  busId: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  fmsObjectId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isGeolocation: Scalars['Boolean']['output'];
  key: Key;
  keyId: Scalars['String']['output'];
};

export type FmsObjectNestedObjectInputType = {
  update?: InputMaybe<Array<UpdateFmsObjectNestedInputType>>;
};

export type FmsObjectWhereInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type FmsObjectWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type GenerateSegmentsWhereInput = {
  route?: InputMaybe<RouteWhereUniqueInput>;
  transfer?: InputMaybe<TransferUniqueWhereInput>;
};

export type Image = {
  __typename?: 'Image';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type ImageNestedObjectInputType = {
  create?: InputMaybe<Array<CreateImageDataInput>>;
  delete?: InputMaybe<Array<ImageWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateImageNestedInputType>>;
};

export type ImageWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
};

export type Key = {
  __typename?: 'Key';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type KeyDataInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type KeyWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Language = {
  __typename?: 'Language';
  code: LanguageCode;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguageCode {
  Cs = 'CS',
  En = 'EN',
  Pl = 'PL',
  Ru = 'RU',
  Uk = 'UK'
}

export type LanguageConnectDisconnectInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LanguageWhereInput = {
  code?: InputMaybe<EnumLanguageCodeFilter>;
};

export type LanguageWhereUniqueInput = {
  code: LanguageCode;
};

export type MergePassengersWhereInput = {
  duplicatedId: Scalars['String']['input'];
  originId: Scalars['String']['input'];
};

export type Message = {
  __typename?: 'Message';
  asReplayMessage: Array<Message>;
  attachments: Array<MessageAttachment>;
  conversation: Conversation;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByPassenger?: Maybe<Passenger>;
  createdByPassengerId?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDelivered: Scalars['Boolean']['output'];
  isIncomingCall: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  isUnsuccessful: Scalars['Boolean']['output'];
  isViberLike: Scalars['Boolean']['output'];
  replayTo?: Maybe<Message>;
  replayToId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  id: Scalars['String']['output'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum MessageType {
  File = 'File',
  Media = 'Media',
  Text = 'Text'
}

export type MessageWhereInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type MessagesPayload = {
  __typename?: 'MessagesPayload';
  action: MessagesPayloadAction;
  conversation: Conversation;
  data: Array<Message>;
};

export enum MessagesPayloadAction {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated'
}

export enum Messenger {
  FacebookMessenger = 'FacebookMessenger',
  InstagramMessenger = 'InstagramMessenger',
  Signal = 'Signal',
  Telegram = 'Telegram',
  Viber = 'Viber',
  WeChat = 'WeChat',
  WhatsApp = 'WhatsApp'
}

export type Metadata = {
  __typename?: 'Metadata';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MetadataDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataNestedObjectInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptSharedRoute: SharedRoute;
  addToBlacklist: Blacklist;
  archiveBusSystemTicket: BusSystemTicket;
  archiveOrder: Order;
  checkContrabusBooking: CheckContrabusBookingPayload;
  confirmCompany?: Maybe<Company>;
  confirmPartner: User;
  copyRoute: Route;
  createBlogArticle: BlogArticle;
  createCarriage: Carriage;
  createCity: City;
  createCityStop: CityStop;
  createCompanyRefundRule: CompanyRefundRule;
  createCompanyShortcut: CompanyShortcut;
  createCompanySource: CompanySource;
  createExchangeRate: ExchangeRate;
  createFbPage: FbPage;
  createImage?: Maybe<Image>;
  createMessage: Array<Message>;
  createOrder: Array<Ticket>;
  createOrigin: Origin;
  createPartnerCommission: PartnerCommission;
  createPromocode: Promocode;
  createRoute: Route;
  createSource: Source;
  createSourceOrder: Array<Order>;
  createStop: Stop;
  createTransfer: Transfer;
  createUser: User;
  createViberChannel: Scalars['Boolean']['output'];
  deleteCarriage: Carriage;
  deleteCity: City;
  deleteCityStop: CityStop;
  deleteCompany: Company;
  deleteCompanyRefundRule: CompanyRefundRule;
  deleteCompanyShortcut: CompanyShortcut;
  deleteCompanySource: CompanySource;
  deleteDiscount: Discount;
  deleteDynamicPrice: DynamicPrice;
  deleteFbPage: FbPage;
  deleteImage?: Maybe<Image>;
  deleteKey: Key;
  deleteMessage: Message;
  deleteOrigin: Origin;
  deletePartnerCommission: PartnerCommission;
  deletePromocode: Promocode;
  deleteSegment: Segment;
  deleteSharedRoute: SharedRoute;
  deleteSource: Source;
  deleteStop: Stop;
  deleteTransfer: Transfer;
  disableViberChannel: Scalars['Boolean']['output'];
  generateSegments: Array<Segment>;
  mergePassengers?: Maybe<Passenger>;
  preLogin: PreLoginPayload;
  readMessages: Array<Message>;
  refreshFbPageAccessToken: FbPage;
  registerCompany: RegisterCompanyPayload;
  registerPartner: RegisterPartnerPayload;
  removeFromBlacklist: Blacklist;
  resetApiKey: Partner;
  resetCompanyApiKey: Company;
  resetUserPassword: Scalars['Boolean']['output'];
  selectAdditionalBus: Array<Order>;
  shareRoute: SharedRoute;
  syncBuses: Scalars['Boolean']['output'];
  transferOrder: Order;
  unarchiveOrder: Order;
  unblockOrder: Order;
  updateBlacklist: Blacklist;
  updateBlockedSeats: RouteByDate;
  updateBlogArticle: BlogArticle;
  updateBus: Bus;
  updateCarriage: Carriage;
  updateCarriagesOrder: Array<Carriage>;
  updateCity: City;
  updateCityStop: CityStop;
  updateCompany: Company;
  updateCompanyRefundRule: CompanyRefundRule;
  updateCompanyShortcut: CompanyShortcut;
  updateCompanySource: CompanySource;
  updateCompanyUser: CompanyUser;
  updateDiscount: Discount;
  updateImage?: Maybe<Image>;
  updateOrder: Order;
  updateOrders: Array<Order>;
  updateOrigin: Origin;
  updatePartnerCommission: PartnerCommission;
  updatePassenger: Passenger;
  updatePrice: Price;
  updatePromocode: Promocode;
  updateReviewAnswerText: Review;
  updateRoute: Route;
  updateRoutesOrder: Array<Route>;
  updateSegments: Array<Segment>;
  updateSettings: Settings;
  updateSource: Source;
  updateSourcesOrder: Array<Source>;
  updateStop: Stop;
  updateStopsOrder: Array<Stop>;
  updateUser: User;
  updateUserPassword: Scalars['Boolean']['output'];
  upsertBusScheme: Array<BusScheme>;
  upsertDynamicPrice: DynamicPrice;
  upsertRouteByDate: RouteByDate;
  upsertSelectedRoute: SelectedRoute;
  upsertSourceByDate: SourceByDate;
  upsertStopByDate: StopByDate;
  userLogin: UserLoginPayload;
  userRelogin: UserLoginPayload;
};


export type MutationAcceptSharedRouteArgs = {
  where: SharedRouteWhereUniqueInput;
};


export type MutationAddToBlacklistArgs = {
  data: AddToBlacklistDataInput;
};


export type MutationArchiveBusSystemTicketArgs = {
  where: BusSystemTicketWhereUniqueInput;
};


export type MutationArchiveOrderArgs = {
  data?: InputMaybe<ArchiveOrderDataInput>;
  where: OrderWhereUniqueInput;
};


export type MutationCheckContrabusBookingArgs = {
  where: CheckContrabusBookingWhereInput;
};


export type MutationConfirmCompanyArgs = {
  data: ConfirmCompanyDataInput;
  token: Scalars['String']['input'];
};


export type MutationConfirmPartnerArgs = {
  data: ConfirmPartnerDataInput;
  token: Scalars['String']['input'];
};


export type MutationCopyRouteArgs = {
  data: CopyRouteDataInput;
};


export type MutationCreateBlogArticleArgs = {
  data: CreateBlogArticleDataInput;
};


export type MutationCreateCarriageArgs = {
  data: CreateCarriageDataInput;
};


export type MutationCreateCityArgs = {
  data: CreateCityDataInput;
};


export type MutationCreateCityStopArgs = {
  data: CreateCityStopDataInput;
};


export type MutationCreateCompanyRefundRuleArgs = {
  data: CreateCompanyRefundRuleDataInput;
};


export type MutationCreateCompanyShortcutArgs = {
  data: CreateCompanyShortcutDataInput;
};


export type MutationCreateCompanySourceArgs = {
  data: CreateCompanySourceDataInput;
};


export type MutationCreateExchangeRateArgs = {
  data: CreateExchangeRateDataInput;
};


export type MutationCreateFbPageArgs = {
  data: CreateFbPageDataInput;
};


export type MutationCreateImageArgs = {
  data: CreateImageDataInput;
};


export type MutationCreateMessageArgs = {
  data: CreateMessageDataInput;
};


export type MutationCreateOrderArgs = {
  data: CreateOrderDataInput;
};


export type MutationCreateOriginArgs = {
  data: CreateOriginDataInput;
};


export type MutationCreatePartnerCommissionArgs = {
  data: CreatePartnerCommissionDataInput;
};


export type MutationCreatePromocodeArgs = {
  data: CreatePromocodeDataInput;
};


export type MutationCreateRouteArgs = {
  data: CreateRouteDataInput;
};


export type MutationCreateSourceArgs = {
  data: CreateSourceDataInput;
};


export type MutationCreateSourceOrderArgs = {
  data: CreateSourceOrderDataInput;
};


export type MutationCreateStopArgs = {
  data: CreateStopDataInput;
};


export type MutationCreateTransferArgs = {
  data: CreateTransferDataInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserDataInput;
};


export type MutationCreateViberChannelArgs = {
  where: PhoneWhereUniqueInput;
};


export type MutationDeleteCarriageArgs = {
  where: CarriageWhereUniqueInput;
};


export type MutationDeleteCityArgs = {
  where: CityWhereUniqueInput;
};


export type MutationDeleteCityStopArgs = {
  where: CityStopWhereUniqueInput;
};


export type MutationDeleteCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteCompanyRefundRuleArgs = {
  where: CompanyRefundRuleWhereUniqueInput;
};


export type MutationDeleteCompanyShortcutArgs = {
  where: CompanyShortcutWhereUniqueInput;
};


export type MutationDeleteCompanySourceArgs = {
  where: CompanySourceWhereUniqueInput;
};


export type MutationDeleteDiscountArgs = {
  where: DiscountWhereUniqueInput;
};


export type MutationDeleteDynamicPriceArgs = {
  where: DynamicPriceWhereUniqueInput;
};


export type MutationDeleteFbPageArgs = {
  where: FbPageWhereUniqueInput;
};


export type MutationDeleteImageArgs = {
  where: ImageWhereUniqueInput;
};


export type MutationDeleteKeyArgs = {
  where: KeyWhereUniqueInput;
};


export type MutationDeleteMessageArgs = {
  where: MessageWhereUniqueInput;
};


export type MutationDeleteOriginArgs = {
  where: OriginWhereUniqueInput;
};


export type MutationDeletePartnerCommissionArgs = {
  where: PartnerCommissionWhereUniqueInput;
};


export type MutationDeletePromocodeArgs = {
  where: PromocodeWhereUniqueInput;
};


export type MutationDeleteSegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type MutationDeleteSharedRouteArgs = {
  where: SharedRouteWhereUniqueInput;
};


export type MutationDeleteSourceArgs = {
  where: SourceWhereUniqueInput;
};


export type MutationDeleteStopArgs = {
  where: StopWhereUniqueInput;
};


export type MutationDeleteTransferArgs = {
  where: TransferUniqueWhereInput;
};


export type MutationDisableViberChannelArgs = {
  where: PhoneWhereUniqueInput;
};


export type MutationGenerateSegmentsArgs = {
  where: GenerateSegmentsWhereInput;
};


export type MutationMergePassengersArgs = {
  where: MergePassengersWhereInput;
};


export type MutationPreLoginArgs = {
  data: PreLoginDataInput;
};


export type MutationReadMessagesArgs = {
  where: MessageWhereInput;
};


export type MutationRefreshFbPageAccessTokenArgs = {
  data: RefreshFbPageAccessTokenDataInput;
  where: FbPageWhereUniqueInput;
};


export type MutationRegisterCompanyArgs = {
  data: RegisterCompanyDataInput;
};


export type MutationRegisterPartnerArgs = {
  data: RegisterPartnerDataInput;
};


export type MutationRemoveFromBlacklistArgs = {
  where: BlacklistWhereUniqueInput;
};


export type MutationResetApiKeyArgs = {
  where: PartnerWhereUniqueInput;
};


export type MutationResetCompanyApiKeyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationResetUserPasswordArgs = {
  where: UserWhereUniqueInput;
};


export type MutationSelectAdditionalBusArgs = {
  data: SelectAdditionalBusDataInput;
  where: OrderWhereInput;
};


export type MutationShareRouteArgs = {
  data: ShareRouteDataInput;
};


export type MutationSyncBusesArgs = {
  data: KeyDataInput;
};


export type MutationTransferOrderArgs = {
  data: TransferOrderDataInput;
  where: OrderWhereUniqueInput;
};


export type MutationUnarchiveOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationUnblockOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationUpdateBlacklistArgs = {
  data: UpdateBlacklistDataInput;
  where: BlacklistWhereUniqueInput;
};


export type MutationUpdateBlockedSeatsArgs = {
  data: BlockedSeatsConnectDisconnectInput;
  where: BlockedSeatsWhereInput;
};


export type MutationUpdateBlogArticleArgs = {
  data: UpdateBlogArticleDataInput;
  where: BlogArticleWhereUniqueInput;
};


export type MutationUpdateBusArgs = {
  data: UpdateBusDataInput;
  where: BusWhereUniqueInput;
};


export type MutationUpdateCarriageArgs = {
  data: UpdateCarriageDataInput;
  where: CarriageWhereUniqueInput;
};


export type MutationUpdateCarriagesOrderArgs = {
  data: Array<CarriageOrderDataInput>;
};


export type MutationUpdateCityArgs = {
  data: UpdateCityDataInput;
  where: CityWhereUniqueInput;
};


export type MutationUpdateCityStopArgs = {
  data: UpdateCityStopDataInput;
  where: CityStopWhereUniqueInput;
};


export type MutationUpdateCompanyArgs = {
  data: UpdateCompanyDataInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpdateCompanyRefundRuleArgs = {
  data: UpdateCompanyRefundRuleDataInput;
  where: CompanyRefundRuleWhereUniqueInput;
};


export type MutationUpdateCompanyShortcutArgs = {
  data: UpdateCompanyShortcutDataInput;
  where: CompanyShortcutWhereUniqueInput;
};


export type MutationUpdateCompanySourceArgs = {
  data: UpdateCompanySourceDataInput;
  where: CompanySourceWhereUniqueInput;
};


export type MutationUpdateCompanyUserArgs = {
  data: UpdateCompanyUserDataInput;
  where: CompanyUserWhereUniqueInput;
};


export type MutationUpdateDiscountArgs = {
  data: DiscountUpdateDataInput;
  where: DiscountWhereUniqueInput;
};


export type MutationUpdateImageArgs = {
  data: UpdateImageDataInput;
  where: ImageWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateDataInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOrdersArgs = {
  data: Array<UpdateOrdersDataInput>;
};


export type MutationUpdateOriginArgs = {
  data: UpdateOriginDataInput;
  where: OriginWhereUniqueInput;
};


export type MutationUpdatePartnerCommissionArgs = {
  data: UpdatePartnerCommissionDataInput;
  where: PartnerCommissionWhereUniqueInput;
};


export type MutationUpdatePassengerArgs = {
  data: UpdatePassengerDataInput;
  where: PassengerWhereUniqueInput;
};


export type MutationUpdatePriceArgs = {
  data: UpdatePriceDataInput;
  where: PriceWhereUniqueInput;
};


export type MutationUpdatePromocodeArgs = {
  data: UpdatePromocodeDataInput;
  where: PromocodeWhereUniqueInput;
};


export type MutationUpdateReviewAnswerTextArgs = {
  data: UpdateReviewAnswerTextDataInput;
  where: ReviewWhereUniqueInput;
};


export type MutationUpdateRouteArgs = {
  data: UpdateRouteDataInput;
  where: RouteWhereUniqueInput;
};


export type MutationUpdateRoutesOrderArgs = {
  data: Array<RouteOrderDataInput>;
};


export type MutationUpdateSegmentsArgs = {
  data: Array<UpdateSegmentsDataInput>;
};


export type MutationUpdateSettingsArgs = {
  data: UpdateSettingsDataInput;
};


export type MutationUpdateSourceArgs = {
  data: UpdateSourceDataInput;
  where: SourceWhereUniqueInput;
};


export type MutationUpdateSourcesOrderArgs = {
  data: Array<SourceOrderInput>;
};


export type MutationUpdateStopArgs = {
  data: UpdateStopDataInput;
  where: StopWhereUniqueInput;
};


export type MutationUpdateStopsOrderArgs = {
  data: Array<StopOrderDataInput>;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserDataInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserPasswordArgs = {
  data: UserUpdatePasswordDataInput;
};


export type MutationUpsertBusSchemeArgs = {
  data: UpsertBusSchemeDataInput;
  where: BusWhereUniqueInput;
};


export type MutationUpsertDynamicPriceArgs = {
  create: DynamicPriceCreateDataInput;
  update: DynamicPriceUpdateDataInput;
  where: DynamicPriceWhereUniqueInput;
};


export type MutationUpsertRouteByDateArgs = {
  create: CreateRouteByDateDataInput;
  extraData?: InputMaybe<UpsertRouteByDateExtraDataInput>;
  update: UpdateRouteByDateDataInput;
  where: RouteByDateWhereUniqueInput;
};


export type MutationUpsertSelectedRouteArgs = {
  create: CreateSelectedRouteDataInput;
  update: UpdateSelectedRouteDataInput;
  where: SelectedRouteWhereUniqueInput;
};


export type MutationUpsertSourceByDateArgs = {
  create: CreateSourceByDateDataInput;
  update: UpdateSourceByDateDataInput;
  where: SourceByDateWhereUniqueInput;
};


export type MutationUpsertStopByDateArgs = {
  create: CreateStopByDateDataInput;
  update: UpdateStopByDateDataInput;
  where: StopByDateWhereUniqueInput;
};


export type MutationUserLoginArgs = {
  data: UserLoginDataInput;
};


export type MutationUserReloginArgs = {
  data: UserReloginDataInput;
};

export type Notification = {
  __typename?: 'Notification';
  data: NotificationData;
  type: NotificationType;
};

/** Possible data types for a notification */
export type NotificationData = NotificationFbData | NotificationOrderData;

export type NotificationFbData = {
  __typename?: 'NotificationFbData';
  isSomeOfFbPagesAccessTokensExpiring: Scalars['Boolean']['output'];
};

export type NotificationOrderData = {
  __typename?: 'NotificationOrderData';
  orderId: Scalars['String']['output'];
};

export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  action: NotificationPayloadAction;
  data: NotificationData;
  type: NotificationType;
};

export enum NotificationPayloadAction {
  Created = 'Created',
  Deleted = 'Deleted'
}

export enum NotificationType {
  ExpiringFbToken = 'ExpiringFbToken',
  FailedUpdateExternalOrder = 'FailedUpdateExternalOrder',
  RefundOrder = 'RefundOrder',
  UncompletedExternalOrder = 'UncompletedExternalOrder'
}

export type OccupiedSeatsPayload = {
  __typename?: 'OccupiedSeatsPayload';
  ids: Array<Scalars['String']['output']>;
};

export type OccupiedSeatsWhereInput = {
  busId: Scalars['String']['input'];
  departureDate: Scalars['DateTime']['input'];
  routeId: Scalars['String']['input'];
};

export type Offer = {
  __typename?: 'Offer';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  borderWaitingMinMaxTime?: Maybe<Array<Scalars['Int']['output']>>;
  departureDay?: Maybe<Scalars['Int']['output']>;
  discounts: Array<Discount>;
  id: Scalars['String']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  partnerCommission?: Maybe<Scalars['Decimal']['output']>;
  prices: Array<Price>;
  returnDay?: Maybe<Scalars['Int']['output']>;
  seatsLeft: Scalars['Int']['output'];
  slices: Array<Slice>;
  source: OrderRouteSource;
};

export type OfferData = {
  __typename?: 'OfferData';
  id: Scalars['String']['output'];
  slices: Array<OfferDataSlice>;
};

export type OfferDataSlice = {
  __typename?: 'OfferDataSlice';
  additionalBuses: Array<AdditionalBus>;
  bus?: Maybe<Bus>;
  carriage?: Maybe<Carriage>;
  carrier?: Maybe<User>;
  firstDriver?: Maybe<User>;
  generalInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  infoForDrivers?: Maybe<Scalars['String']['output']>;
  infoForPartners?: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  permissions: Array<RoutePermission>;
  routeByDateId?: Maybe<Scalars['String']['output']>;
  routeDepartureDate: Scalars['DateTime']['output'];
  routeName: Scalars['String']['output'];
  secondDriver?: Maybe<User>;
  stops: Array<OfferDataSliceStop>;
  thirdDriver?: Maybe<User>;
};

export type OfferDataSliceStop = {
  __typename?: 'OfferDataSliceStop';
  arrivalTime?: Maybe<Scalars['String']['output']>;
  byDateId?: Maybe<Scalars['String']['output']>;
  city: City;
  departureTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

export type OfferDataWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type OfferWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type OffersPayload = {
  __typename?: 'OffersPayload';
  results: Array<Offer>;
  source: OrderRouteSource;
};

export type OffersWhereInput = {
  arrivalCitySlug: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  departureCitySlug: Scalars['String']['input'];
  departureDate: Scalars['DateTime']['input'];
};

export type Order = {
  __typename?: 'Order';
  additionalBus?: Maybe<AdditionalBus>;
  additionalBusId?: Maybe<Scalars['String']['output']>;
  arrivalCity?: Maybe<City>;
  arrivalCityId?: Maybe<Scalars['String']['output']>;
  arrivalPlace?: Maybe<Scalars['String']['output']>;
  arrivalPlatform?: Maybe<Scalars['String']['output']>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  asCompanyWebsiteOrder?: Maybe<Company>;
  asCompanyWebsiteOrderCompanyId?: Maybe<Scalars['String']['output']>;
  busSeat?: Maybe<BusScheme>;
  busSeatId?: Maybe<Scalars['String']['output']>;
  carriageDiscount?: Maybe<Discount>;
  carriageDiscountId?: Maybe<Scalars['String']['output']>;
  companyCommission?: Maybe<Scalars['Decimal']['output']>;
  contrabusDataBundle?: Maybe<Scalars['String']['output']>;
  contrabusReqData?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyCode>;
  departureCity?: Maybe<City>;
  departureCityId?: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['DateTime']['output'];
  departurePlace?: Maybe<Scalars['String']['output']>;
  departurePlatform?: Maybe<Scalars['String']['output']>;
  departureTime?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalCarrierName?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalRouteName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isBlocked: Scalars['Boolean']['output'];
  isWithExternalError?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Origin>;
  originId?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Decimal']['output']>;
  paidCurrency?: Maybe<CurrencyCode>;
  partner?: Maybe<Partner>;
  partnerCommission?: Maybe<Scalars['Decimal']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  passenger?: Maybe<Passenger>;
  passengerId?: Maybe<Scalars['String']['output']>;
  paymentProvider: OrderPaymentProvider;
  paymentRecipient?: Maybe<OrderPaymentRecipient>;
  paymentStatus: PaymentStatus;
  phones: Array<Phone>;
  prepaid?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  promocode?: Maybe<Promocode>;
  promocodeId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['String']['output']>;
  routeSource: OrderRouteSource;
  seat?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Segment>;
  segmentId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Source>;
  sourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  transfers: Array<OrderTransfer>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrderAppPlatform {
  Android = 'Android',
  Ios = 'Ios'
}

export type OrderByCountInput = {
  _count: SortOrder;
};

export enum OrderChannel {
  Api = 'Api',
  Application = 'Application',
  Backoffice = 'Backoffice',
  CarrierWebsite = 'CarrierWebsite',
  Website = 'Website'
}

export type OrderHistory = {
  __typename?: 'OrderHistory';
  id: Scalars['String']['output'];
  nextData: OrderHistoryData;
  prevData?: Maybe<OrderHistoryData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type OrderHistoryData = {
  __typename?: 'OrderHistoryData';
  additionalBus?: Maybe<Bus>;
  arrivalCity?: Maybe<City>;
  arrivalPlace?: Maybe<Scalars['String']['output']>;
  arrivalPlatform?: Maybe<Scalars['String']['output']>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyCode>;
  departureCity?: Maybe<City>;
  departurePlace?: Maybe<Scalars['String']['output']>;
  departurePlatform?: Maybe<Scalars['String']['output']>;
  departureTime?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  seat?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
};

export type OrderHistoryWhereInput = {
  orderId: Scalars['String']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  departureDate?: InputMaybe<SortOrder>;
};

export enum OrderPaymentProvider {
  LiqPay = 'LiqPay',
  Stripe = 'Stripe'
}

export enum OrderPaymentRecipient {
  Agent = 'Agent',
  Carrier = 'Carrier',
  PrexSell = 'PrexSell'
}

export enum OrderRouteSource {
  BlaBlaCar = 'BlaBlaCar',
  ContraBus = 'ContraBus',
  Klr = 'Klr',
  OctoBus = 'OctoBus',
  PrexSell = 'PrexSell',
  Toco = 'Toco'
}

export type OrderRouteSourceFilter = {
  equals?: InputMaybe<OrderRouteSource>;
  not?: InputMaybe<OrderRouteSource>;
};

export enum OrderStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  ConfirmedAutomatically = 'ConfirmedAutomatically',
  NotConfirmed = 'NotConfirmed',
  Processing = 'Processing',
  Refund = 'Refund',
  Uncompleted = 'Uncompleted',
  Waiting = 'Waiting'
}

export type OrderSummary = {
  __typename?: 'OrderSummary';
  amount: Scalars['Decimal']['output'];
  currency: CurrencyCode;
  paymentStatus: PaymentStatus;
};

export type OrderTransfer = {
  __typename?: 'OrderTransfer';
  additionalBus?: Maybe<AdditionalBus>;
  additionalBusId?: Maybe<Scalars['String']['output']>;
  busSeat?: Maybe<BusScheme>;
  busSeatId?: Maybe<Scalars['String']['output']>;
  departureDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  route: Route;
  routeId: Scalars['String']['output'];
  seat?: Maybe<Scalars['String']['output']>;
  transfer?: Maybe<Transfer>;
  transferId?: Maybe<Scalars['String']['output']>;
};

export type OrderTransfersListRelationFilter = {
  every?: InputMaybe<OrderTransfersWhereInput>;
  none?: InputMaybe<OrderTransfersWhereInput>;
  some?: InputMaybe<OrderTransfersWhereInput>;
};

export type OrderTransfersWhereInput = {
  departureDate?: InputMaybe<DateTimeFilter>;
  route?: InputMaybe<RouteWhereInput>;
};

export type OrderUpdateDataInput = {
  arrivalStop?: InputMaybe<CityStopConnectDisconnectInput>;
  currency?: InputMaybe<CurrencyCode>;
  departureStop?: InputMaybe<CityStopConnectDisconnectInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isWithNotification?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRecipient?: InputMaybe<OrderPaymentRecipient>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  phones?: InputMaybe<Array<PhoneWhereUniqueInput>>;
  prepaid?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  seat?: InputMaybe<PassengerSeatDataInput>;
  status?: InputMaybe<OrderStatus>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  asCompanyWebsiteOrderCompanyId?: InputMaybe<StringFilter>;
  channel?: InputMaybe<EnumOrderChannelFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  createdById?: InputMaybe<StringFilter>;
  departureDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isBlocked?: InputMaybe<BoolFilter>;
  partner?: InputMaybe<PartnerWhereInput>;
  partnerId?: InputMaybe<StringFilter>;
  paymentProvider?: InputMaybe<EnumOrderPaymentProviderFilter>;
  paymentStatus?: InputMaybe<EnumPaymentStatusFilter>;
  route?: InputMaybe<RouteWhereInput>;
  routeSource?: InputMaybe<OrderRouteSourceFilter>;
  sourceId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  transfers?: InputMaybe<OrderTransfersListRelationFilter>;
};

export type OrderWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type OrdersByDateWhereInput = {
  departureDate?: InputMaybe<DateTimeFilter>;
  isBlocked?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
};

export type OrdersQty = {
  __typename?: 'OrdersQty';
  all: Scalars['Int']['output'];
  lastTwoYears: Scalars['Int']['output'];
};

export type OrdersSummary = {
  __typename?: 'OrdersSummary';
  summary: Array<OrderSummary>;
  total: Scalars['Int']['output'];
};

export type Origin = {
  __typename?: 'Origin';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orders: Array<Order>;
};


export type OriginOrdersArgs = {
  orderBy?: InputMaybe<OrderOrderByInput>;
  where?: InputMaybe<OrderWhereInput>;
};

export type OriginConnectInput = {
  connect?: InputMaybe<OriginWhereUniqueInput>;
};

export type OriginWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Partner = {
  __typename?: 'Partner';
  apiKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  role: UserRole;
  selectedRoutes: Array<SelectedRoute>;
  user: User;
};

export type PartnerCommission = {
  __typename?: 'PartnerCommission';
  amount: Scalars['Decimal']['output'];
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  partner: Partner;
  partnerId: Scalars['String']['output'];
  source: OrderRouteSource;
};

export type PartnerCommissionOrderByInput = {
  amount?: InputMaybe<SortOrder>;
  companyName?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
};

export type PartnerCommissionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type PartnerConnectInput = {
  connect: PartnerWhereUniqueInput;
};

export type PartnerUpdateDeleteInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<UpdatePartnerDataInput>;
};

export type PartnerWhereInput = {
  OR?: InputMaybe<Array<PartnerWhereInput>>;
  role?: InputMaybe<UserRole>;
  user?: InputMaybe<UserWhereInput>;
};

export type PartnerWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Passenger = {
  __typename?: 'Passenger';
  asCompanyPassenger: Array<CompanyPassenger>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  blacklist: Array<Blacklist>;
  email?: Maybe<Scalars['String']['output']>;
  facebookPageScopedId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAppOrder: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isRegular: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  ordersQty: OrdersQty;
  ordersSum: Scalars['Int']['output'];
  phones: Array<Phone>;
  socials: Array<Scalars['String']['output']>;
};


export type PassengerOrdersArgs = {
  orderBy?: InputMaybe<OrderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type PassengerOrdersQtyArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type PassengerActivity = {
  __typename?: 'PassengerActivity';
  call?: Maybe<PassengerActivityCall>;
  chat?: Maybe<PassengerActivityChat>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  order?: Maybe<PassengerActivityOrder>;
  type: PassengerActivityType;
};

export type PassengerActivityCall = {
  __typename?: 'PassengerActivityCall';
  answerPhone?: Maybe<Scalars['String']['output']>;
  callId: Scalars['String']['output'];
  incomingPhone?: Maybe<Scalars['String']['output']>;
  linkToCall?: Maybe<Scalars['String']['output']>;
  linkToRecord?: Maybe<Scalars['String']['output']>;
};

export type PassengerActivityChat = {
  __typename?: 'PassengerActivityChat';
  conversationId: Scalars['String']['output'];
  messagesCount: Scalars['String']['output'];
};

export type PassengerActivityOrder = {
  __typename?: 'PassengerActivityOrder';
  departureDate: Scalars['DateTime']['output'];
  externalRouteName?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  routeId?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  routeSource: OrderRouteSource;
};

export enum PassengerActivityType {
  Call = 'Call',
  Chat = 'Chat',
  Order = 'Order'
}

export type PassengerSeatDataInput = {
  busSeatId?: InputMaybe<Scalars['String']['input']>;
  busSeatLabel?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export enum PassengerStatus {
  Priority = 'Priority',
  Regular = 'Regular',
  Usual = 'Usual'
}

export type PassengerWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PassengersOrderByInput = {
  firstName?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderByCountInput>;
};

export enum PaymentStatus {
  Booked = 'Booked',
  Paid = 'Paid',
  Prepaid = 'Prepaid',
  Unpaid = 'Unpaid'
}

export enum PermissionType {
  Partner = 'Partner',
  Website = 'Website'
}

export type Phone = {
  __typename?: 'Phone';
  createdAt: Scalars['DateTime']['output'];
  eChatApiKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  messengers: Array<Messenger>;
  passenger?: Maybe<Passenger>;
  passengerId?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type PhoneCodeDataInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
};

export type PhoneConnectOrCreateInput = {
  create: CreatePhoneDataInput;
  where: PhoneWhereUniqueInput;
};

export type PhoneListRelationFilter = {
  every?: InputMaybe<PhoneWhereInput>;
  none?: InputMaybe<PhoneWhereInput>;
  some?: InputMaybe<PhoneWhereInput>;
};

export type PhoneNestedObjectInputType = {
  connectOrCreate?: InputMaybe<Array<PhoneConnectOrCreateInput>>;
  disconnect?: InputMaybe<Array<PhoneWhereUniqueInput>>;
};

export type PhoneUpsertInput = {
  create: CreatePhoneDataInput;
  update: UpdatePhoneDataInput;
  where: PhoneWhereUniqueInput;
};

export type PhoneWhereInput = {
  id?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
};

export type PhoneWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  tier: PlanTier;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlanTier {
  Basic = 'Basic',
  Free = 'Free',
  Pro = 'Pro'
}

export type PopularDestinationWhereInput = {
  citySlug: Scalars['String']['input'];
};

export type PreLoginDataInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type PreLoginPayload = {
  __typename?: 'PreLoginPayload';
  user: User;
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Decimal']['output'];
  currency: CurrencyCode;
  dynamicPrices: Array<DynamicPrice>;
  id: Scalars['String']['output'];
  segment: Segment;
};


export type PriceAmountArgs = {
  where?: InputMaybe<PriceAmountWhereInput>;
};


export type PriceDynamicPricesArgs = {
  where?: InputMaybe<DynamicPriceWhereInput>;
};

export type PriceAmountWhereInput = {
  departureDate: DateTimeFilter;
};

export type PriceWhereInput = {
  segment?: InputMaybe<SegmentWhereInput>;
};

export type PriceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Promocode = {
  __typename?: 'Promocode';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  rule: PromocodeRule;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  used: Scalars['Int']['output'];
};

export enum PromocodeRule {
  Percent = 'Percent'
}

export type PromocodeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  availableSeats: Array<AvailableSeatsPayload>;
  blaBlaCarOffers: OffersPayload;
  blacklist: Array<Blacklist>;
  blogArticle: BlogArticle;
  blogArticles: Array<BlogArticle>;
  bookingsLeft: Scalars['Int']['output'];
  borderWaitingTimes: Array<BorderWaitingTime>;
  bus?: Maybe<Bus>;
  busSystemOrders: Array<Order>;
  busSystemRoutes: Array<BusSystemRoute>;
  busesLocations: Array<BusLocation>;
  carrierOrders: Array<Order>;
  carriersByDates: Array<CarrierByDate>;
  cities: Array<City>;
  city: City;
  closestAvailableOffers: ClosestAvailableOffers;
  companies: Array<Company>;
  company?: Maybe<Company>;
  companyRefundRules: Array<CompanyRefundRule>;
  contrabusOffers: OffersPayload;
  conversation?: Maybe<Conversation>;
  conversations: Array<Conversation>;
  dashboard: Dashboard;
  duplicatedOrders: Array<Order>;
  dynamicPrices: Array<DynamicPrice>;
  externalOfferData: ExternalOfferData;
  externalOfferPrice: Price;
  fmsKeys: Array<Key>;
  fmsObjects: Array<FmsObject>;
  klrOffers: OffersPayload;
  latestExchangeRates: Array<ExchangeRate>;
  messages: Array<Message>;
  notifications: Array<Notification>;
  occupiedSeats: OccupiedSeatsPayload;
  octobusOffers: OffersPayload;
  offerData: OfferData;
  offerRouteByDate?: Maybe<RouteByDate>;
  offers: OffersPayload;
  order?: Maybe<Order>;
  orderHistory: Array<OrderHistory>;
  orders: Array<Order>;
  ordersCSVUrl: Scalars['String']['output'];
  ordersSummary: OrdersSummary;
  origins: Array<Origin>;
  partnerCommissions: Array<PartnerCommission>;
  partners: Array<Partner>;
  passenger?: Maybe<Passenger>;
  passengerActivity: Array<PassengerActivity>;
  passengers: Array<Passenger>;
  phone?: Maybe<Phone>;
  promocodes: Array<Promocode>;
  route?: Maybe<Route>;
  routeByDate: RouteByDate;
  routeByDateHistory: Array<RouteByDateHistory>;
  routeServices: Array<RouteService>;
  routeSummary: RouteSummary;
  routes: Array<Route>;
  searchOrders: Array<Order>;
  settings: Settings;
  sourcesByDatesHistory: Array<SourceByDateHistory>;
  sourcesSummary: Array<SourceSummary>;
  stats?: Maybe<Stats>;
  stopsByDatesHistory: Array<StopByDateHistory>;
  tocobusOffers: OffersPayload;
  transfer: Transfer;
  unhandledBusSystemTickets: Array<BusSystemTicket>;
  unreadMessages: Array<Message>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type QueryAvailableSeatsArgs = {
  where: AvailableSeatsWhereInput;
};


export type QueryBlaBlaCarOffersArgs = {
  where: OffersWhereInput;
};


export type QueryBlacklistArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlogArticleArgs = {
  where: BlogArticleWhereUniqueInput;
};


export type QueryBlogArticlesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogArticleWhereInput>;
};


export type QueryBookingsLeftArgs = {
  where: BookingsLeftWhereInput;
};


export type QueryBusArgs = {
  where: BusWhereUniqueInput;
};


export type QueryBusSystemOrdersArgs = {
  where: BusSystemOrdersWhereInput;
};


export type QueryCarrierOrdersArgs = {
  where: CarrierOrdersWhereInput;
};


export type QueryCarriersByDatesArgs = {
  where: CarriersByDatesWhereInput;
};


export type QueryCitiesArgs = {
  where?: InputMaybe<CityWhereInput>;
};


export type QueryCityArgs = {
  where: CityWhereUniqueInput;
};


export type QueryClosestAvailableOffersArgs = {
  where: OffersWhereInput;
};


export type QueryCompaniesArgs = {
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryCompanyRefundRulesArgs = {
  where: CompanyRefundRuleWhereInput;
};


export type QueryContrabusOffersArgs = {
  where: OffersWhereInput;
};


export type QueryConversationArgs = {
  where: ConversationWhereUniqueInput;
};


export type QueryConversationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type QueryDashboardArgs = {
  where: DashboardWhereInput;
};


export type QueryDuplicatedOrdersArgs = {
  where: DuplicatedOrderWhereInput;
};


export type QueryDynamicPricesArgs = {
  where: DynamicPriceWhereInput;
};


export type QueryExternalOfferDataArgs = {
  where: ExternalOfferDataWhereInput;
};


export type QueryExternalOfferPriceArgs = {
  where: ExternalOfferPriceWhereInput;
};


export type QueryFmsObjectsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FmsObjectWhereInput>;
};


export type QueryKlrOffersArgs = {
  where: OffersWhereInput;
};


export type QueryMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageWhereInput>;
};


export type QueryOccupiedSeatsArgs = {
  where: OccupiedSeatsWhereInput;
};


export type QueryOctobusOffersArgs = {
  where: OffersWhereInput;
};


export type QueryOfferDataArgs = {
  where: OfferDataWhereUniqueInput;
};


export type QueryOfferRouteByDateArgs = {
  where: OfferWhereUniqueInput;
};


export type QueryOffersArgs = {
  where: OffersWhereInput;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrderHistoryArgs = {
  where: OrderHistoryWhereInput;
};


export type QueryOrdersArgs = {
  orderBy?: InputMaybe<OrderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: OrderWhereInput;
};


export type QueryOrdersCsvUrlArgs = {
  where: OrderWhereInput;
};


export type QueryOrdersSummaryArgs = {
  where: OrderWhereInput;
};


export type QueryPartnerCommissionsArgs = {
  orderBy?: InputMaybe<PartnerCommissionOrderByInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPassengerArgs = {
  where: PassengerWhereUniqueInput;
};


export type QueryPassengerActivityArgs = {
  where: PassengerWhereUniqueInput;
};


export type QueryPassengersArgs = {
  orderBy?: InputMaybe<PassengersOrderByInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPhoneArgs = {
  where: PhoneWhereInput;
};


export type QueryRouteArgs = {
  where: RouteWhereUniqueInput;
};


export type QueryRouteByDateArgs = {
  where: RouteByDateWhereUniqueInput;
};


export type QueryRouteByDateHistoryArgs = {
  where: RouteByDateWhereUniqueInput;
};


export type QueryRouteSummaryArgs = {
  where: RouteSummaryWhereInput;
};


export type QueryRoutesArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<RouteOrderByInput>>>;
  where?: InputMaybe<RouteWhereInput>;
};


export type QuerySearchOrdersArgs = {
  where: SearchOrdersWhereInput;
};


export type QuerySourcesByDatesHistoryArgs = {
  where: RouteByDateWhereUniqueInput;
};


export type QuerySourcesSummaryArgs = {
  where: SourcesSummaryWhereInput;
};


export type QueryStopsByDatesHistoryArgs = {
  where: RouteByDateWhereUniqueInput;
};


export type QueryTocobusOffersArgs = {
  where: OffersWhereInput;
};


export type QueryTransferArgs = {
  where: TransferUniqueWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  where: UserWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Intensitive = 'intensitive'
}

export type RefreshFbPageAccessTokenDataInput = {
  accessToken: Scalars['String']['input'];
};

export type RegisterCompanyDataInput = {
  email: Scalars['String']['input'];
  planTier: PlanTier;
  prexsellCommission: Scalars['Float']['input'];
};

export type RegisterCompanyPayload = {
  __typename?: 'RegisterCompanyPayload';
  company: Company;
  link: Scalars['String']['output'];
};

export type RegisterPartnerDataInput = {
  email: Scalars['String']['input'];
  role: UserRole;
};

export type RegisterPartnerPayload = {
  __typename?: 'RegisterPartnerPayload';
  link?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Review = {
  __typename?: 'Review';
  answerText?: Maybe<Scalars['String']['output']>;
  bus: Scalars['Int']['output'];
  comfort: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  drivers: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  orderInfo?: Maybe<ReviewOrderInfo>;
  passenger: Passenger;
  passengerId: Scalars['String']['output'];
  priceQuality: Scalars['Int']['output'];
  rating: Scalars['Float']['output'];
  support: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ReviewOrderInfo = {
  __typename?: 'ReviewOrderInfo';
  carriageName?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySlug?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  firstDriver?: Maybe<User>;
  routeName?: Maybe<Scalars['String']['output']>;
  secondDriver?: Maybe<User>;
  thirdDriver?: Maybe<User>;
};

export type ReviewWhereInput = {
  AND?: InputMaybe<Array<ReviewWhereInput>>;
  OR?: InputMaybe<Array<ReviewWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
};

export type ReviewWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Route = {
  __typename?: 'Route';
  asReturnRoute?: Maybe<Route>;
  asSharedRoute: Array<SharedRoute>;
  busSystemRoute?: Maybe<BusSystemRoute>;
  byDates: Array<RouteByDate>;
  carriages: Array<Carriage>;
  company: Company;
  companyId: Scalars['String']['output'];
  confirmMsgHour?: Maybe<Scalars['Int']['output']>;
  defaultOrdersLimit: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  dynamicPrices: Array<DynamicPrice>;
  id: Scalars['String']['output'];
  isCopyGenerating: Scalars['Boolean']['output'];
  isInternational: Scalars['Boolean']['output'];
  isSegmentsGenerating: Scalars['Boolean']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  orders: Array<Order>;
  ordersByDate: Array<Order>;
  permissions: Array<RoutePermission>;
  returnDay?: Maybe<Scalars['Int']['output']>;
  returnRoute?: Maybe<Route>;
  returnRouteId?: Maybe<Scalars['String']['output']>;
  salesDepth: Scalars['Int']['output'];
  seatsLeftByDate?: Maybe<Scalars['Int']['output']>;
  segments: Array<Segment>;
  services?: Maybe<Array<RouteService>>;
  slug: Scalars['String']['output'];
  sources: Array<Source>;
  status: RouteStatus;
  stops: Array<Stop>;
  translations: Array<RouteTranslation>;
};


export type RouteByDatesArgs = {
  orderBy?: InputMaybe<RouteByDateOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteByDateWhereInput>;
};


export type RouteCarriagesArgs = {
  orderBy?: InputMaybe<CarriageOrderByInput>;
};


export type RouteOrdersArgs = {
  orderBy?: InputMaybe<OrderOrderByInput>;
  where?: InputMaybe<OrderWhereInput>;
};


export type RouteOrdersByDateArgs = {
  where?: InputMaybe<OrdersByDateWhereInput>;
};


export type RouteSeatsLeftByDateArgs = {
  where?: InputMaybe<OrdersByDateWhereInput>;
};


export type RouteSegmentsArgs = {
  where?: InputMaybe<SegmentWhereInput>;
};


export type RouteSourcesArgs = {
  orderBy?: InputMaybe<SourceOrderByInput>;
};


export type RouteStopsArgs = {
  orderBy?: InputMaybe<StopOrderByInput>;
  where?: InputMaybe<StopWhereInput>;
};

export enum RouteAccess {
  Booking = 'Booking',
  Management = 'Management',
  Order = 'Order'
}

export type RouteByDate = {
  __typename?: 'RouteByDate';
  additionalBuses: Array<AdditionalBus>;
  blockedSeats: Array<BusScheme>;
  bus?: Maybe<Bus>;
  busId?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<User>;
  carrierId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  firstDriver?: Maybe<User>;
  firstDriverId?: Maybe<Scalars['String']['output']>;
  generalInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  infoForDrivers?: Maybe<Scalars['String']['output']>;
  infoForPartners?: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  ordersLimit?: Maybe<Scalars['Int']['output']>;
  route: Route;
  routeId: Scalars['String']['output'];
  secondDriver?: Maybe<User>;
  secondDriverId?: Maybe<Scalars['String']['output']>;
  thirdDriver?: Maybe<User>;
  thirdDriverId?: Maybe<Scalars['String']['output']>;
};


export type RouteByDateAdditionalBusesArgs = {
  where?: InputMaybe<AdditionalBusWhereUniqueInput>;
};

export type RouteByDateHistory = {
  __typename?: 'RouteByDateHistory';
  id: Scalars['String']['output'];
  nextData: RouteByDateHistoryData;
  prevData?: Maybe<RouteByDateHistoryData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type RouteByDateHistoryData = {
  __typename?: 'RouteByDateHistoryData';
  additionalBuses?: Maybe<Array<AdditionalBusHistoryData>>;
  bus?: Maybe<Bus>;
  carrier?: Maybe<User>;
  firstDriver?: Maybe<User>;
  generalInfo?: Maybe<Scalars['String']['output']>;
  infoForDrivers?: Maybe<Scalars['String']['output']>;
  infoForPartners?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  ordersLimit?: Maybe<Scalars['Int']['output']>;
  secondDriver?: Maybe<User>;
  thirdDriver?: Maybe<User>;
};

export type RouteByDateOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type RouteByDateWhereInput = {
  AND?: InputMaybe<Array<RouteByDateWhereInput>>;
  OR?: InputMaybe<Array<RouteByDateWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
};

export type RouteByDateWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RouteConnectInput = {
  connect?: InputMaybe<RouteWhereUniqueInput>;
};

export type RouteOrderByInput = {
  companyId?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type RouteOrderDataInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type RoutePermission = {
  __typename?: 'RoutePermission';
  accesses: Array<RouteAccess>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role?: Maybe<UserRole>;
  routeId: Scalars['String']['output'];
  type: PermissionType;
};

export type RoutePermissionCreateDataInput = {
  accesses: Array<RouteAccess>;
  role?: InputMaybe<UserRole>;
  type: PermissionType;
};

export type RoutePermissionListRelationFilter = {
  every?: InputMaybe<RoutePermissionWhereInput>;
  none?: InputMaybe<RoutePermissionWhereInput>;
  some?: InputMaybe<RoutePermissionWhereInput>;
};

export type RoutePermissionNestedObjectInputType = {
  upsert?: InputMaybe<Array<RoutePermissionUpsertInput>>;
};

export type RoutePermissionUpdateDataInput = {
  accesses?: InputMaybe<Array<RouteAccess>>;
  role?: InputMaybe<UserRole>;
  type?: InputMaybe<PermissionType>;
};

export type RoutePermissionUpsertInput = {
  create: RoutePermissionCreateDataInput;
  update: RoutePermissionUpdateDataInput;
  where: RoutePermissionWhereUniqueInput;
};

export type RoutePermissionWhereInput = {
  accesses?: InputMaybe<AccessesNestedInput>;
  role?: InputMaybe<UserRole>;
  type?: InputMaybe<PermissionType>;
};

export type RoutePermissionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RouteService = {
  __typename?: 'RouteService';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  translations: Array<RouteServiceTranslation>;
};

export type RouteServiceConnectDisconnectInput = {
  connect?: InputMaybe<Array<RouteServiceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RouteServiceWhereUniqueInput>>;
};

export type RouteServiceTranslation = {
  __typename?: 'RouteServiceTranslation';
  id: Scalars['String']['output'];
  language: Language;
  name: Scalars['String']['output'];
};

export type RouteServiceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export enum RouteStatus {
  Archived = 'Archived',
  Disabled = 'Disabled',
  Draft = 'Draft',
  Private = 'Private',
  Public = 'Public'
}

export type RouteSummary = {
  __typename?: 'RouteSummary';
  data: Array<RouteSummaryData>;
  exchangedTotals: Array<RouteSummaryTotal>;
  generalTotal: RouteSummaryGeneralTotal;
  totalsByCurrencies: Array<RouteSummaryTotal>;
};

export enum RouteSummaryCreatedBy {
  Agent = 'Agent',
  Dispatcher = 'Dispatcher',
  Source = 'Source'
}

export type RouteSummaryData = {
  __typename?: 'RouteSummaryData';
  createdBy: RouteSummaryCreatedBy;
  currency: CurrencyCode;
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
  paymentStatus: PaymentStatus;
};

export type RouteSummaryGeneralTotal = {
  __typename?: 'RouteSummaryGeneralTotal';
  currency: CurrencyCode;
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
};

export type RouteSummaryTotal = {
  __typename?: 'RouteSummaryTotal';
  currency: CurrencyCode;
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
  paymentStatus: PaymentStatus;
};

export type RouteSummaryWhereInput = {
  departureDate: Scalars['DateTime']['input'];
  route: RouteWhereUniqueInput;
};

export type RouteTranslation = {
  __typename?: 'RouteTranslation';
  id: Scalars['String']['output'];
  language: Language;
  name: Scalars['String']['output'];
};

export type RouteTranslationCreateDataInput = {
  language: LanguageConnectDisconnectInput;
  name: Scalars['String']['input'];
};

export type RouteTranslationNestedObjectInputType = {
  create?: InputMaybe<Array<RouteTranslationCreateDataInput>>;
  delete?: InputMaybe<Array<RouteTranslationWhereUniqueInput>>;
};

export type RouteTranslationWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RouteWhereInput = {
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<RoutePermissionListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRouteStatusFilter>;
  stops?: InputMaybe<StopListRelationFilter>;
};

export type RouteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SearchOrdersWhereInput = {
  companyId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SearchPassengersWhereInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Seat = {
  __typename?: 'Seat';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type SeatsWhereInput = {
  routeId: Scalars['String']['input'];
};

export type Segment = {
  __typename?: 'Segment';
  arrivalStop: Stop;
  arrivalStopId: Scalars['String']['output'];
  departureStop: Stop;
  departureStopId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['String']['output']>;
  route: Route;
  routeId: Scalars['String']['output'];
  transfers: Array<SegmentTransfer>;
};


export type SegmentTransfersArgs = {
  where?: InputMaybe<SegmentTransfersWhereInput>;
};

export type SegmentTransfer = {
  __typename?: 'SegmentTransfer';
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  segment: Segment;
  segmentId: Scalars['String']['output'];
  transfer: Transfer;
  transferId: Scalars['String']['output'];
};

export type SegmentTransfersWhereInput = {
  transfer?: InputMaybe<TransferWhereInput>;
};

export type SegmentWhereInput = {
  AND?: InputMaybe<Array<SegmentWhereInput>>;
  OR?: InputMaybe<Array<SegmentWhereInput>>;
  arrivalStop?: InputMaybe<StopWhereInput>;
  departureStop?: InputMaybe<StopWhereInput>;
  route?: InputMaybe<RouteWhereInput>;
};

export type SegmentWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SelectAdditionalBusDataInput = {
  additionalBusId?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['String']['input'];
};

export type SelectedRoute = {
  __typename?: 'SelectedRoute';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  routeId: Scalars['String']['output'];
};

export type SelectedRouteWhereUniqueInput = {
  routeId: Scalars['String']['input'];
};

export type Settings = {
  __typename?: 'Settings';
  blaBlaCarSalesDepth: Scalars['Int']['output'];
  contrabusSalesDepth: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  klrSalesDepth: Scalars['Int']['output'];
  octobusSalesDepth: Scalars['Int']['output'];
  tocobusSalesDepth: Scalars['Int']['output'];
};

export type ShareRouteDataInput = {
  companyId: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
};

export type SharedRoute = {
  __typename?: 'SharedRoute';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  route: Route;
};

export type SharedRouteWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedRouteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Slice = {
  __typename?: 'Slice';
  additionalBuses: Array<AdditionalBus>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  blockedSeats?: Maybe<Array<BusScheme>>;
  bus?: Maybe<Bus>;
  carriage?: Maybe<Carriage>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** The first one, in the array - is a segment id, others - are the transfers ids */
  id: Scalars['String']['output'];
  route?: Maybe<SliceRoute>;
  seat?: Maybe<Seat>;
  stops: Array<Stop>;
};

export type SliceRoute = {
  __typename?: 'SliceRoute';
  company?: Maybe<Company>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<RoutePermission>;
  services: Array<RouteService>;
  slug?: Maybe<Scalars['String']['output']>;
  translations: Array<RouteTranslation>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Source = {
  __typename?: 'Source';
  asCompanySource?: Maybe<CompanySource>;
  asCompanySourceId?: Maybe<Scalars['String']['output']>;
  byDates: Array<SourceByDate>;
  commission: Scalars['Float']['output'];
  defaultDepartureCity?: Maybe<City>;
  defaultDepartureCityId?: Maybe<Scalars['String']['output']>;
  defaultDepartureStop?: Maybe<Stop>;
  defaultDepartureStopId?: Maybe<Scalars['String']['output']>;
  defaultOrdersLimit: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  route: Route;
  routeId?: Maybe<Scalars['String']['output']>;
};


export type SourceByDatesArgs = {
  orderBy?: InputMaybe<SourceByDateOrderByInput>;
  where?: InputMaybe<SourceByDateWhereInput>;
};

export type SourceByDate = {
  __typename?: 'SourceByDate';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  ordersLimit: Scalars['Int']['output'];
  source: Source;
  sourceId: Scalars['String']['output'];
};

export type SourceByDateHistory = {
  __typename?: 'SourceByDateHistory';
  id: Scalars['String']['output'];
  nextData: SourceByDateHistoryData;
  prevData?: Maybe<SourceByDateHistoryData>;
  source: Source;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type SourceByDateHistoryData = {
  __typename?: 'SourceByDateHistoryData';
  ordersLimit?: Maybe<Scalars['Int']['output']>;
};

export type SourceByDateOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type SourceByDateWhereInput = {
  date?: InputMaybe<DateTimeFilter>;
};

export type SourceByDateWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SourceConnectInput = {
  connect?: InputMaybe<SourceWhereUniqueInput>;
};

export type SourceOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type SourceOrderInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type SourceOrdersSummary = {
  __typename?: 'SourceOrdersSummary';
  currency: CurrencyCode;
  profit: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export type SourceSummary = {
  __typename?: 'SourceSummary';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ordersSummary: Array<SourceOrdersSummary>;
};

export type SourceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SourcesSummaryWhereInput = {
  carrierId?: InputMaybe<Scalars['String']['input']>;
  companySourceId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  paymentStatus: PaymentStatus;
  routeId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type Stats = {
  __typename?: 'Stats';
  passengers?: Maybe<Scalars['Int']['output']>;
  routesMade?: Maybe<Scalars['Int']['output']>;
};

export type Stop = {
  __typename?: 'Stop';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  arrivalDay: Scalars['Int']['output'];
  arrivalTime?: Maybe<Scalars['String']['output']>;
  asFromTransfers: Array<Transfer>;
  asToTransfers: Array<Transfer>;
  byDates: Array<StopByDate>;
  city: City;
  cityId: Scalars['String']['output'];
  cityStop?: Maybe<CityStop>;
  cityStopId?: Maybe<Scalars['String']['output']>;
  departureDay: Scalars['Int']['output'];
  departureTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  place?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  route: Route;
  routeId: Scalars['String']['output'];
};


export type StopByDatesArgs = {
  orderBy?: InputMaybe<StopByDateOrderByInput>;
  where?: InputMaybe<StopByDateWhereInput>;
};

export type StopByDate = {
  __typename?: 'StopByDate';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  stop: Stop;
  stopId: Scalars['String']['output'];
};

export type StopByDateHistory = {
  __typename?: 'StopByDateHistory';
  id: Scalars['String']['output'];
  nextData: StopByDateHistoryData;
  prevData?: Maybe<StopByDateHistoryData>;
  stop: Stop;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type StopByDateHistoryData = {
  __typename?: 'StopByDateHistoryData';
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type StopByDateOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export type StopByDateWhereInput = {
  date?: InputMaybe<DateTimeFilter>;
};

export type StopByDateWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type StopConnectDisconnectInput = {
  connect?: InputMaybe<StopWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StopConnectInput = {
  connect?: InputMaybe<StopWhereUniqueInput>;
};

export type StopListRelationFilter = {
  every?: InputMaybe<StopWhereInput>;
  none?: InputMaybe<StopWhereInput>;
  some?: InputMaybe<StopWhereInput>;
};

export type StopOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type StopOrderDataInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type StopWhereInput = {
  city?: InputMaybe<CityWhereInput>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export type StopWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  busLocation: BusLocation;
  messages: MessagesPayload;
  notification: NotificationPayload;
};


export type SubscriptionBusLocationArgs = {
  where?: InputMaybe<BusLocationWhereInput>;
};

export type Ticket = {
  __typename?: 'Ticket';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  carriageDiscount?: Maybe<Discount>;
  createdAt: Scalars['DateTime']['output'];
  departureDate: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  id: Scalars['String']['output'];
  initialPrice?: Maybe<Price>;
  isArchived: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  passenger: Passenger;
  paymentStatus: PaymentStatus;
  prepaid?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Price>;
  promocode?: Maybe<Promocode>;
  reviewId?: Maybe<Scalars['String']['output']>;
  /** Departure date of the route. Could be the same as the departureDate or earlier */
  routeDepartureDate: Scalars['DateTime']['output'];
  slices: Array<Slice>;
  source: OrderRouteSource;
  status?: Maybe<OrderStatus>;
};

export type TicketWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type TicketsWhereInput = {
  ids: Array<Scalars['String']['input']>;
};

export type Transfer = {
  __typename?: 'Transfer';
  fromStop: Stop;
  fromStopId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleting: Scalars['Boolean']['output'];
  isSegmentsGenerating: Scalars['Boolean']['output'];
  segments: Array<Segment>;
  toStop: Stop;
  toStopId: Scalars['String']['output'];
};

export type TransferOrderDataInput = {
  departureDate: Scalars['DateTime']['input'];
  offerId: Scalars['String']['input'];
};

export type TransferUniqueWhereInput = {
  id: Scalars['String']['input'];
};

export type TransferWhereInput = {
  OR?: InputMaybe<Array<TransferWhereInput>>;
  fromStop?: InputMaybe<StopWhereInput>;
  toStop?: InputMaybe<StopWhereInput>;
};

export type UpdateBlacklistDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlogArticleDataInput = {
  category: BlogArticleCategory;
  content?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<UpdateBlogArticleMetadataDataInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlogArticleMetadataDataInput = {
  update: UpdateMetadataDataInput;
};

export type UpdateBusDataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  fmsObjects?: InputMaybe<FmsObjectNestedObjectInputType>;
  images?: InputMaybe<ImageNestedObjectInputType>;
  model?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  seatsQty?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCarriageDataInput = {
  carrier?: InputMaybe<UserConnectDisconnectInput>;
  customDays?: InputMaybe<Array<Scalars['String']['input']>>;
  discounts?: InputMaybe<DiscountNestedObjectInputType>;
  frequency?: InputMaybe<CarriageFrequency>;
  nDay?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCityDataInput = {
  country: CountryCode;
  name: Scalars['String']['input'];
  translations: Array<UpdateCityTranslationDataInput>;
};

export type UpdateCityStopDataInput = {
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  place: Scalars['String']['input'];
};

export type UpdateCityTranslationDataInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCompanyDataInput = {
  addresses?: InputMaybe<CompanyAddressNestedObjectInputType>;
  busSystemLogin?: InputMaybe<Scalars['String']['input']>;
  busSystemPassword?: InputMaybe<Scalars['String']['input']>;
  buses?: InputMaybe<CompanyBusNestedObjectInputType>;
  ceo?: InputMaybe<Scalars['String']['input']>;
  dispatcherCommission?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationsEmail?: InputMaybe<Scalars['String']['input']>;
  notificationsPhone?: InputMaybe<Scalars['String']['input']>;
  partnerCommission?: InputMaybe<Scalars['Float']['input']>;
  partnerCompany?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<CompanyPhoneNestedObjectInputType>;
  planTier?: InputMaybe<PlanTier>;
  prexsellCommission?: InputMaybe<Scalars['Float']['input']>;
  reviewLink?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socials?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CompanyStatus>;
  website?: InputMaybe<Scalars['String']['input']>;
  websiteConfig?: InputMaybe<CompanyWebsiteConfigNestedObjectInputType>;
};

export type UpdateCompanyRefundRuleDataInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  hours?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCompanyShortcutDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanySourceDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyUserDataInput = {
  role?: InputMaybe<UserRole>;
};

export type UpdateFmsObjectDataInput = {
  isGeolocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFmsObjectNestedInputType = {
  data: UpdateFmsObjectDataInput;
  where: FmsObjectWhereUniqueInput;
};

export type UpdateImageDataInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateImageNestedInputType = {
  data: UpdateImageDataInput;
  where: ImageWhereUniqueInput;
};

export type UpdateMetadataDataInput = {
  data: MetadataDataInput;
};

export type UpdateOrdersDataInput = {
  update: OrderUpdateDataInput;
  where: OrderWhereUniqueInput;
};

export type UpdateOriginDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerCommissionDataInput = {
  amount: Scalars['Decimal']['input'];
};

export type UpdatePartnerDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePassengerDataInput = {
  asCompanyPassenger?: InputMaybe<Array<AsCompanyPassengerDataInput>>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneCodeDataInput>>;
  socials?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<PassengerStatus>;
};

export type UpdatePhoneDataInput = {
  messengers?: InputMaybe<Array<Messenger>>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePriceDataInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CurrencyCode>;
  dynamicPrices?: InputMaybe<DynamicPriceNestedObjectInputType>;
};

export type UpdatePromocodeDataInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<PromocodeRule>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateReviewAnswerTextDataInput = {
  answerText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRouteByDateDataInput = {
  additionalBuses?: InputMaybe<AdditionalBusesUpdateDataInput>;
  bus?: InputMaybe<BusConnectDisconnectInput>;
  carrier?: InputMaybe<UserConnectDisconnectInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  firstDriver?: InputMaybe<UserConnectDisconnectInput>;
  generalInfo?: InputMaybe<Scalars['String']['input']>;
  infoForDrivers?: InputMaybe<Scalars['String']['input']>;
  infoForPartners?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  ordersLimit?: InputMaybe<Scalars['Int']['input']>;
  secondDriver?: InputMaybe<UserConnectDisconnectInput>;
  thirdDriver?: InputMaybe<UserConnectDisconnectInput>;
};

export type UpdateRouteDataInput = {
  busSystemRoute?: InputMaybe<BusSystemRouteConnectInput>;
  company?: InputMaybe<CompanyConnectInput>;
  confirmMsgHour?: InputMaybe<Scalars['Int']['input']>;
  defaultOrdersLimit?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<DiscountNestedObjectInputType>;
  dynamicPrices?: InputMaybe<DynamicPriceNestedObjectInputType>;
  isInternational?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<RoutePermissionNestedObjectInputType>;
  returnDay?: InputMaybe<Scalars['Int']['input']>;
  returnRoute?: InputMaybe<RouteConnectInput>;
  salesDepth?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<RouteServiceConnectDisconnectInput>;
  status?: InputMaybe<RouteStatus>;
  translations?: InputMaybe<RouteTranslationNestedObjectInputType>;
};

export type UpdateSegmentsDataInput = {
  price: CreatePriceDataInput;
  where: SegmentWhereUniqueInput;
};

export type UpdateSelectedRouteDataInput = {
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSettingsDataInput = {
  blaBlaCarSalesDepth: Scalars['Int']['input'];
  contrabusSalesDepth: Scalars['Int']['input'];
  klrSalesDepth: Scalars['Int']['input'];
  octobusSalesDepth: Scalars['Int']['input'];
  tocobusSalesDepth: Scalars['Int']['input'];
};

export type UpdateSourceByDateDataInput = {
  ordersLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSourceDataInput = {
  asCompanySource?: InputMaybe<CompanySourceConnectInput>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  defaultDepartureStop?: InputMaybe<StopConnectDisconnectInput>;
  defaultOrdersLimit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStopByDateDataInput = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStopDataInput = {
  arrivalDay?: InputMaybe<Scalars['Int']['input']>;
  arrivalTime?: InputMaybe<Scalars['String']['input']>;
  cityStop?: InputMaybe<CityStopConnectInput>;
  departureDay?: InputMaybe<Scalars['Int']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTicketDataInput = {
  update: UpdateTicketUpdateDataInput;
  where: TicketWhereUniqueInput;
};

export type UpdateTicketUpdateDataInput = {
  discountId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phones: Array<CreatePhoneDataInput>;
  seats?: InputMaybe<Array<PassengerSeatDataInput>>;
};

export type UpdateUserDataInput = {
  asCompaniesUser?: InputMaybe<CompanyUserCreateDeleteInput>;
  asPartner?: InputMaybe<PartnerUpdateDeleteInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  isChatNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBusSchemeDataInput = {
  createMany: CreateManyBusSchemeDataInput;
  deleteMany: Array<InputMaybe<BusSchemeWhereUniqueInput>>;
};

export type UpsertRouteByDateExtraDataInput = {
  isUpdateReturnRoute?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  asCompaniesUser: Array<CompanyUser>;
  asPartner?: Maybe<Partner>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isChatNotificationsEnabled: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserOrdersArgs = {
  orderBy?: InputMaybe<OrderOrderByInput>;
  where?: InputMaybe<OrderWhereInput>;
};

export type UserConnectDisconnectInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLoginDataInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserLoginPayload = {
  __typename?: 'UserLoginPayload';
  companyId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  companyTier?: Maybe<PlanTier>;
  token: Scalars['String']['output'];
  user: User;
};

export type UserReloginDataInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum UserRole {
  Admin = 'Admin',
  Agent = 'Agent',
  Carrier = 'Carrier',
  Dispatcher = 'Dispatcher',
  Driver = 'Driver'
}

export type UserUpdatePasswordDataInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UserWhereInput = {
  asPartner?: InputMaybe<PartnerWhereInput>;
  email?: InputMaybe<StringFilter>;
  role?: InputMaybe<UserRole>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteConfig = {
  __typename?: 'WebsiteConfig';
  additionalRoutesCompanies: Array<Company>;
  additionalRoutesSources: Array<OrderRouteSource>;
  applePayDomainFileUrl?: Maybe<Scalars['String']['output']>;
  defaultMetadata?: Maybe<Metadata>;
  defaultMetadataId?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  liqpayPrivateKey?: Maybe<Scalars['String']['output']>;
  liqpayPublicKey?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export enum Weekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}
